import { useCallback } from "react"
import { graphql, useMutation, UseMutationConfig } from "react-relay"
import { useDeDeleteSickLeaveMutation as useDeDeleteSickLeaveMutationType } from "@/modules/patients/detail/sick-leave-certificate/de/services/__generated__/useDeDeleteSickLeaveMutation.graphql"

const deleteSickLeaveMutation = graphql`
  mutation useDeDeleteSickLeaveMutation($input: De_deleteSickLeaveInput!) {
    de_deleteSickLeave(input: $input) {
      de_SickLeave {
        id @deleteRecord
      }
    }
  }
`

const useDeDeleteSickLeaveMutation = () => {
  const [commit, isFlight] = useMutation<useDeDeleteSickLeaveMutationType>(deleteSickLeaveMutation)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useDeDeleteSickLeaveMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useDeDeleteSickLeaveMutation }
